import { SearchQueryForOptimize } from "../models";

/** Default N for bulk "Select rows" (first N visible rows). */
export const TABLE_BULK_SELECTION_DEFAULT_ROW_COUNT = 10;
/** Max IDs per server-search request when fetching grid rows by id ($in). */
export const MAX_SEARCH_IDS_BATCH_SIZE = 500;

/** Default react-window overscan rows for grouped table wrapper when not dragging. */
export const TABLE_WRAPPER_DEFAULT_OVERSCAN_COUNT = 2;
/** Extra react-window overscan rows while dragging between grids (non-drag uses {@link TABLE_WRAPPER_DEFAULT_OVERSCAN_COUNT}). */
export const TABLE_WRAPPER_DRAG_OVERSCAN_COUNT = 3;
/** Overscan rows/columns for frozen-header calendar grids (reduces pop-in while wheel scrolling). */
export const VIRTUALIZED_GRID_OVERSCAN_COUNT = 3;
/** Delayed safety re-measure of a grouped table wrapper row after layout settles — catches a size-cache wipe that did not resize the row (so the ResizeObserver stays silent) and gives RTL/Hebrew layout time to settle. */
export const GROUPED_TABLE_WRAPPER_ROW_HEIGHT_REFRESH_MS = 100;

export const ID_EMPTY_COLUMN_NAME = "idempty";
export const HANDLING_COLUMN_NAME = "handling";
export const ID_COLUMN_NAME = "id";
export const SETTINGS_COLUMN_NAME = "settingsColumn";
export const LAST_COLUMN_LIVE_MAP = "liveMapLastColumn";
export const ARRIVAL_TIME_COLUMN_LIVE_MAP = "liveMapArrivalTime";
export const needToOptimizeSet = new Set<SearchQueryForOptimize>([
  "rides",
  "bookings",
  "bookingsPassengers",
]);

export const TOP_CALENDAR_MODE_QUERY_NAME = "topCalendarMode";
export const TOP_CALENDAR_DATE1_QUERY_NAME = "date1";
export const TOP_CALENDAR_DATE2_QUERY_NAME = "date2";
